import { InfoCard, EmptyState } from '@backstage/core-components';

export const PolicyComplianceCard = () => (
  <InfoCard title="Policy Compliance">
    <EmptyState
      title="Coming soon"
      missing="data"
      description="Policy compliance scoring will surface here once the Kyverno policy-compliance-tab work is complete. Components will be graded against registered policies and an aggregate pass rate displayed."
    />
  </InfoCard>
);
